function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.0862 1.60132L24.5728 16.0879M24.5728 16.0879L8.88717 31.7735C8.49664 32.164 7.86348 32.164 7.47296 31.7735L1.69922 25.9998M24.5728 16.0879H37M10.4674 30.1934L17.3295 37.0554",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.4535 39.2834L57.8042 45.6341C59.3969 47.2269 61.9794 47.2269 63.5722 45.6341V45.6341C65.1649 44.0413 65.1649 41.4589 63.5722 39.8661L61.5 37.7939",
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.9503 45.3159L54.2071 53.5727C55.7998 55.1655 58.3822 55.1655 59.975 53.5727V53.5727C61.5678 51.9799 61.5678 49.3975 59.975 47.8047L51.7678 39.5975",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.5485 52.4503L47.8731 58.7747C49.4658 60.3675 52.0483 60.3675 53.641 58.7747V58.7747C55.2338 57.1819 55.2338 54.5995 53.641 53.0067L45.9503 45.316",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.1758 51.9215C41.7686 51.5483 41.1361 51.5758 40.7629 51.983C40.3897 52.3901 40.4172 53.0226 40.8243 53.3958L42.1758 51.9215ZM44.5715 55.4742L45.2472 54.7371L44.5715 55.4742ZM39.4239 60.8504L40.131 60.1433L39.4239 60.8504ZM44.6309 60.9066L45.3226 61.6288L44.6309 60.9066ZM40.8243 53.3958L43.8957 56.2114L45.2472 54.7371L42.1758 51.9215L40.8243 53.3958ZM40.131 60.1433L36.4393 56.4515L35.025 57.8657L38.7167 61.5575L40.131 60.1433ZM43.9392 60.1844C42.8698 61.2086 41.178 61.1904 40.131 60.1433L38.7167 61.5575C40.5329 63.3737 43.4677 63.4054 45.3226 61.6288L43.9392 60.1844ZM43.8957 56.2114C45.0554 57.2744 45.0753 59.0962 43.9392 60.1844L45.3226 61.6288C47.2933 59.7412 47.2588 56.5811 45.2472 54.7371L43.8957 56.2114Z",
  fill: "#9F9A98"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 19.0913,
  y: 35.0729,
  width: 7,
  height: 11.9837,
  rx: 3.5,
  transform: "rotate(45 19.0913 35.0729)",
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 24.0411,
  y: 40.0226,
  width: 7,
  height: 13.6854,
  rx: 3.5,
  transform: "rotate(45 24.0411 40.0226)",
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 28.9908,
  y: 44.9723,
  width: 7,
  height: 13.6854,
  rx: 3.5,
  transform: "rotate(45 28.9908 44.9723)",
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33.9406,
  y: 49.922,
  width: 7,
  height: 10.021,
  rx: 3.5,
  transform: "rotate(45 33.9406 49.922)",
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.3254 0.894212C67.716 0.503687 68.3491 0.503687 68.7397 0.894212C69.1302 1.28474 69.1302 1.9179 68.7397 2.30843L54.9602 16.0879L69.9387 31.0664L75.7124 25.2927C76.1029 24.9022 76.7361 24.9022 77.1266 25.2927C77.5172 25.6832 77.5172 26.3164 77.1266 26.7069L71.3529 32.4806C70.5718 33.2617 69.3055 33.2617 68.5245 32.4806L67.6514 31.6075L61.4964 37.7625L60.7893 38.4696L60.0822 37.7625L51.3626 29.0429C50.3931 28.3167 48.6561 27.4322 46.624 27.1729C44.5873 26.9129 42.2674 27.2789 40.0712 29.0633C37.7042 30.9866 36.6876 32.091 35.9391 32.9042L35.9162 32.9292C35.1261 33.7875 34.5552 34.4001 33.1414 35.2167C31.9244 36.1673 30.557 36.3932 29.28 36.1152C28.0137 35.8395 26.8777 35.0819 26.0229 34.1453C25.1683 33.2088 24.5306 32.0237 24.3317 30.8027C24.1295 29.5621 24.3815 28.2396 25.3797 27.2099C26.8547 25.6883 29.816 22.7271 32.4019 20.1528C33.6962 18.8642 34.8988 17.6703 35.7777 16.7986C36.2172 16.3628 36.5758 16.0074 36.8246 15.761L37.0222 15.5653C37.1981 15.2789 37.5142 15.0879 37.875 15.0879H53.1317L67.3254 0.894212ZM38.327 17.0879L38.2321 17.182C37.9836 17.4281 37.6252 17.7832 37.1861 18.2187C36.3078 19.0898 35.1061 20.2827 33.8129 21.5702C31.2236 24.1479 28.2759 27.0957 26.8157 28.6019C26.3464 29.0861 26.1828 29.7271 26.3056 30.4811C26.4317 31.2548 26.8597 32.0953 27.5002 32.7971C28.1405 33.4987 28.929 33.9919 29.7055 34.1609C30.4486 34.3227 31.2163 34.2003 31.9511 33.6081L32.0132 33.5581L32.0824 33.5185C33.2883 32.8294 33.7031 32.3803 34.4447 31.5747L34.4537 31.5648C35.2462 30.7039 36.3312 29.5252 38.81 27.5111C41.4936 25.3307 44.3838 24.8707 46.8773 25.189C49.3393 25.5032 51.4271 26.5741 52.6286 27.4928L52.6813 27.5332L52.7282 27.5801L60.7893 35.6412L66.2372 30.1933L53.1317 17.0879H38.327Z",
  fill: "#3C3C3B"
});

var SvgFeatureOne4 = function SvgFeatureOne4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 78,
    height: 68,
    viewBox: "0 0 78 68",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-4.5febbdbb.svg";
export { ForwardRef as ReactComponent };